import React, { memo } from "react";
import styles from "./styles.module.css";
import cx from "classnames";

export const OffsetType = {
  LEFT: "left",
  RIGHT: "right",
};

export const CardWithExpectation = memo(
  ({ data: { imageUrl, title, description, offset }, className }) => {
    const offsetClass = {
      [OffsetType.LEFT]: styles.right,
      [OffsetType.RIGHT]: styles.left,
    };

    return (
      <div className={cx(className, styles.cardContainer)}>
        <div
          className={cx(styles.relative, styles.imgHeight, offsetClass[offset])}
        >
          <img
            className={styles.image}
            src={imageUrl}
            alt={`${title} изображение`}
          />
        </div>
        <h6 className={styles.cardTitle}>{title}</h6>
        <p className={styles.cardDesc}>{description}</p>
      </div>
    );
  }
);
